import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'components'
import { Table, TableBody, TableCell, TableRow } from 'components/Table'
import { Switch, Typography } from '@material-ui/core'

const BasePermissionsForm = ({
  title,
  permissionsList,
  register,
  permissions,
  handleChange,
  activeProfile,
  isEdit,
  infoBanner,
}) => {
  const handleSwitchOnChange = (event, permission) => {
    if (activeProfile || !isEdit) {
      handleChange(event.target.checked, permission.tag, permission)
    }
  }

  return (
    <Card dropdown title={title}>
      {infoBanner}
      <Table>
        <TableBody>
          {permissionsList?.map((permission) => {
            const checkedValue = isEdit
              ? permissions[permission.tag] ?? true
              : permissions[permission.tag]
            return (
              <TableRow key={permission.tag}>
                <TableCell width="90%" align="left">
                  <Typography variant="subtitle1">{permission.name}</Typography>
                  <Typography variant="body2">
                    {permission?.description}
                  </Typography>
                </TableCell>
                <TableCell width="10%" align="left" disableTooltip>
                  <Switch
                    key={`${permission.tag}-${String(checkedValue)}`}
                    color="primary"
                    name={`permissions[${permission.tag}]`}
                    checked={checkedValue}
                    onChange={(event) =>
                      handleSwitchOnChange(event, permission)
                    }
                  />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Card>
  )
}

BasePermissionsForm.propTypes = {
  title: PropTypes.string,
  permissionsList: PropTypes.array,
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
  activeProfile: PropTypes.bool,
  infoBanner: PropTypes.node,
}

BasePermissionsForm.defaultProps = {
  permissions: {},
  handleChange: () => {},
}

export default BasePermissionsForm
